import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';

import UserService from 'services/UserService';
import { Text } from 'components/FormElements';
import { email, required } from 'constants/InputErrors';
import { logoutUser, toggleAlertError, toggleLoading } from 'stores/actions';

class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      submitted: false,
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    if( this.props.accessToken ) {
      this.props.logoutUser();
    }
    if( this.props.isLoading ) {
      this.props.toggleLoading( false );
    }
  }

  submitForm( data ) {
    this.props.toggleLoading( true );
    UserService.recoverPassword( data ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.errors ) return this.props.toggleAlertError( response.errors );

      this.setState( { submitted: true } )
    } )
  }

  render() {
    return (
      <div className="page-login">
        <div className="main-body">
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">
                <section className="text-center">
                  <img src="assets/images/logo_smm_minsait.png" width={200} className="mb-3"/>
                </section>

                {
                  this.state.submitted ?
                    <p className="my-3 text-center">You should receive an email with instructions to change your password</p> :
                    <Form
                      onSubmit={this.submitForm}
                      validate={values => {
                        return {
                          email: required( values.email ) ? required( values.email ) : email( values.email ),
                        }
                      }}
                    >
                      {( { submitForm } ) =>
                        <form onSubmit={submitForm}>
                          <div className="form-group">
                            <Text field="email" className="form-control" placeholder="email"/>
                          </div>

                          <div className="text-right mt-3">
                            <button type="submit" className="btn btn-info text-uppercase">Recover Password</button>
                          </div>
                        </form>
                      }
                    </Form>
                }
              </div>
            </div>

            <div className="additional-info">
              <a href="#/login">Back to login</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ( state ) => ( {
  accessToken: state.user.access_token,
  isLoading: state.settings.isLoading,
} );

const mapDispatchToProps = dispatch => ( {
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( ForgotPassword );



// WEBPACK FOOTER //
// ./routes/forgot-password/index.js